import { startTransition, StrictMode } from 'react';
import { hydrateRoot } from 'react-dom/client';
import { HydratedRouter } from 'react-router/dom';
import { startWebVitals } from '@/lib/webVitals';

// The browser entry in framework mode (web plan W4.3; it replaces main.tsx's
// createRoot). The document, its head and the providers come from
// src/root.tsx; this only hydrates it.
//
// No component may be declared in this file: that would make it a React
// Refresh boundary, and a dev edit would re-run it (src/entry.client.test.ts).

// Error tracking (web plan W1.5): off unless VITE_SENTRY_DSN is set at build
// time — without it Vite drops this branch and the tracker is not even in the
// bundle; with it, a small chunk loads next to the app.
if (import.meta.env.VITE_SENTRY_DSN) {
  void import('@/lib/errorTracking').then(({ initErrorTracking }) => initErrorTracking());
}
// Real-user Web Vitals to GA4 (web plan W5.2): production builds and people
// only; the measuring library is a small chunk loaded after this point.
void startWebVitals();

startTransition(() => {
  hydrateRoot(
    document,
    <StrictMode>
      <HydratedRouter />
    </StrictMode>,
  );
});
